// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/footer.component.scss
// module id = 294
// module chunks = 0